import { UserbotTemplates } from "../../interfaces"
import { useTemplateQuery, useTemplatesQuery } from "../../store"

/** Имя шаблона из кэша списка chain-шаблонов; null при промахе (спека §5.1). */
export const resolveTemplateName = (
  templateId: string,
  cachedItems: UserbotTemplates.Template[] | undefined,
): string | null => cachedItems?.find((t) => t.id === templateId)?.name ?? null

/** Деградация: усечённый templateId (в UI — моно-шрифтом). */
export const shortTemplateId = (templateId: string): string =>
  templateId.slice(0, 8)

export interface TemplateNameRes {
  name: string
  resolved: boolean
}

/** Резолв имени шаблона: кэш списка → точечный запрос → усечённый id. */
export const useTemplateName = (templateId: string): TemplateNameRes => {
  const { data: cached } = useTemplatesQuery({ kind: "chain", limit: 200 })
  const cachedName = resolveTemplateName(templateId, cached?.items)
  const { data: fetched } = useTemplateQuery(
    { id: templateId },
    { skip: cachedName !== null },
  )
  if (cachedName !== null) return { name: cachedName, resolved: true }
  if (fetched?.name) return { name: fetched.name, resolved: true }
  return { name: shortTemplateId(templateId), resolved: false }
}
